<template>
    <div>
        <Header/>
        <Title v-if='page === "home"'/>
        <Titlearchived v-if='page === "list"'/>
        <div v-if='subtitle' class="notice_header">
            <h2> {{subtitle}} </h2>
        </div>
        <div v-if='store.metadata !== null && store.services !== null'>
            <transition name="fade">
                <router-view class="view"></router-view>
            </transition>
        </div>

        <div v-else>
            <p>Chargement...</p>
        </div>

        <!-- Footer-->
        <footer>
            <Stayathome v-if='page !== "home"'/>
            <div class="bottom">
                <div class="bottom_left">
                    <router-link tag="button" :to="{ name: 'demarche' }" @click.native='pageChange();stats("ClickDemarche")'>Démarche</router-link>
                    <router-link tag="button" :to="{ name: 'notice' }" @click.native='pageChange();stats("ClickNotice")'>Mentions légales</router-link>
                    <router-link tag="button" :to="{ name: 'cgu' }" @click.native='pageChange();stats("ClickCGU")'>Conditions Générales d'Utilisation</router-link>
                    <router-link tag="button" :to="{ name: 'charte' }" @click.native='pageChange();stats("ClickCharte")'>Charte</router-link>
                    <button> <a href="mailto:plateformeinitiativescovid19@grandlyon.com">Contact / Signaler une erreur</a></button>
                </div>
                <div class="bottom_right">
                    <img src="../static/GL_white.svg" alt="Grand Lyon">
                    <img src="../static/footer_image.svg" alt="Restez chez vous">
                    <a href="https://www.grandlyon.com/" target="_blank"> Un site de la Métropole de Lyon </a>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import { getItems, getCollection } from "../utils/requests"
import Title from './Title.vue'
import Titlearchived from './Titlearchived.vue'
import Header from './Header.vue'
import Stayathome from './Stayathome.vue'
import Store from '../utils/store.js'

const SUBTITLES = {
    "notice": "Mentions légales",
    "demarche": "Une démarche collaborative",
    "cgu": "Conditions Générales d'Utilisation",
    "charte": "Charte des services accessibles sur la plateforme aide-covid.grandlyon.com"
}

export default {
    name: 'MainPage',
    components: {
        Title,
        Titlearchived,
        Header,
        Stayathome
    },
    data: function() {
        return {
            store: Store,
            url: Store.url,
            project: Store.project,
            metadata: Store.metadata,
            table: Store.table,
            table_news: Store.table_news,
            services: Store.services,
        }
    },
    computed: {
        page: function() {
            return this.$route.name;
        },
        subtitle: function() {
            return SUBTITLES[this.page];
        }
    },
    created: function() {
        // TODO : gérer les erreurs
        getItems("initiatives.json")
            .then((ret) => {
                this.store.services = ret["data"];
            }
        );
        getItems("files-url.json")
            .then((ret) => {
                this.store.files = ret;
            }
        );
        getCollection( "initiatives-metadata.json")
            .then((ret) => {
                this.store.metadata = ret["data"];
            }
        );
        getItems("actualites.json")
            .then((ret) => {
                this.store.news = ret["data"];
            }
        );
    },
    methods: {
        pageChange: function() {
            window.scrollTo(0, 0);
        },
        stats: function(actionName) {
            _paq.push(["trackEvent", "HomePage", actionName]);
        }
    }
}
var _paq = window._paq || [];
</script>

<style scoped>
.fade-enter-active  {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.notice_header{
    background-color: var(--medium-grey);
    padding: 1.5% 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.notice_header img{
    padding-right: 5px;
    width: 20%;
}

.left_back{
    display: inline-block;
    position:absolute;
    left: 0;
    padding-left: 3%;
    cursor: pointer;
}

footer{
  bottom:0;
}

footer a{
    color: white;
    text-decoration: none;
}

.bottom {
  background: black;
  padding: 1% 10% 1% 10%;
  display: flex;
  align-items: center;
}

.bottom button, .notice_header button, .bottom_right a{
    color: white;
    text-decoration: none;
    background: none;
    border: none;
    margin-right: 3%;
}

.bottom_left{
    display: flex;
    justify-content: left;
    width: 70%;
    float: left;
}
.bottom_right{
  display: flex;
  position: absolute;
  right: 10%;
  width: 30%;
  justify-content: flex-end;
  font-weight: bold;
}

.bottom_right img{
    margin-left: 5%;
}

@media (max-width: 600px) {

    .bottom {
      padding: 1% 10% 1% 10%;
      display: block;
      align-items: center;
    }

    .bottom button, .notice_header button, .bottom_right a{
        color: white;
        text-decoration: none;
        background: none;
        border: none;
        margin: 2% 0;
        width: 100%;
        font-size: 3vw
    }

    .bottom_left{
        display: block;
        justify-content: center;
        margin: 2% 0;
        width: 100%;
    }

    .bottom_right{
      display: flex;
      position: relative;
      right: 0;
      width: 100%;
      justify-content: center;
      font-weight: bold;
      margin: 10% 0 5% 0;
    }

    .notice_header{
        background-color: var(--medium-grey);
        padding: 0.5% 0;
        display: block;
        align-items: center;
        justify-content: center;
    }

    .notice_header img{
        padding-right: 5px;
        width: 5%;
    }

    .left_back{
        width: 100%;
        display: flex;
        position:relative;
        left: 3%;
        justify-content: left;
    }

    .left_back button{
        text-align: left;
        font-size: 3vw;
    }
}

</style>
